





import Vue from 'vue'
import moment from 'moment/moment'
import request from '@/utils/request'
export default Vue.extend({
    data() {
        return {
            barId: '' as any,
            detailId: '' as any,
            data: {},
            show: true,
        }
    },
    created() {
        console.log(this.$route.params)
        // const {barId, detailId} = this.$route.query
        // this.barId = barId
        // this.detailId = detailId
        // this.getData(barId, detailId)
    },
    methods: {
        getData(barId: any, detailId: any) {
            let url = `/api/cultural/article_rest/${detailId}`
            if (barId === '11') {
                url = `/api/cultural/venue_rest/${detailId}`
            }
            request.get(url).then((result) => {
                if (result) {
                    result.time = moment(result.createTime).format('YYYY-MM-DD')
                    this.data = result
                } else {
                    this.data = {}
                }
            }).catch(() => {
                console.log('88')
            })
        },
    },
    filters: {
    },
})
